module.exports = __webpack_public_path__ + "img/invoice_optional.9d664a76.png";